module.exports = __webpack_public_path__ + "img/Cover_HW_26.8e39ee3a.jpg";